import { EpimsBaseEntityDto } from './epim-base.dto';
export class SuitCounselDto extends EpimsBaseEntityDto {

    CounselId: string;
    CounselName: string;   
    AdrId: string;
    SuitNo: string;
  	CounselTypeId: string;	
    CounselStatus: string;	
    Remarks	: string;
}
	
